// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from TextInput-Hint.module.scss  */
.TextInput-Hint-module-Root_2Wu {
  display: inline-block;
  margin-top: 9px;
  font-family: var(--textinput-font-family);
  font-size: var(--textinput-size-l-font-size-hint);
  line-height: var(--textinput-size-l-line-height-hint);
  color: var(--textinput-variant-default-color-hint);
  animation: TextInput-Hint-module-Hint_show_23P 100ms ease-in forwards; }
  .TextInput-Hint-module-Root_2Wu.TextInput-Hint-module-leave_3Dm {
    animation: TextInput-Hint-module-Hint_leave_3UB 100ms ease-out forwards; }

@keyframes TextInput-Hint-module-Hint_leave_3UB {
  to {
    opacity: 0;
    transform: translateY(-6px); }
  from {
    opacity: 1;
    transform: translateY(0); } }

@keyframes TextInput-Hint-module-Hint_show_23P {
  from {
    opacity: 0;
    transform: translateY(-6px); }
  to {
    opacity: 1;
    transform: translateY(0); } }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/TextInput/Hint/TextInput-Hint.css"],"names":[],"mappings":"AAAA,+CAA+C;AAC/C;EACE,qBAAqB;EACrB,eAAe;EACf,yCAAyC;EACzC,iDAAiD;EACjD,qDAAqD;EACrD,kDAAkD;EAClD,qEAAqE,EAAE;EACvE;IACE,uEAAuE,EAAE;;AAE7E;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,wBAAwB,EAAE,EAAE;;AAEhC;EACE;IACE,UAAU;IACV,2BAA2B,EAAE;EAC/B;IACE,UAAU;IACV,wBAAwB,EAAE,EAAE","sourcesContent":["/*  imported from TextInput-Hint.module.scss  */\n.TextInput-Hint-module-Root_2Wu {\n  display: inline-block;\n  margin-top: 9px;\n  font-family: var(--textinput-font-family);\n  font-size: var(--textinput-size-l-font-size-hint);\n  line-height: var(--textinput-size-l-line-height-hint);\n  color: var(--textinput-variant-default-color-hint);\n  animation: TextInput-Hint-module-Hint_show_23P 100ms ease-in forwards; }\n  .TextInput-Hint-module-Root_2Wu.TextInput-Hint-module-leave_3Dm {\n    animation: TextInput-Hint-module-Hint_leave_3UB 100ms ease-out forwards; }\n\n@keyframes TextInput-Hint-module-Hint_leave_3UB {\n  to {\n    opacity: 0;\n    transform: translateY(-6px); }\n  from {\n    opacity: 1;\n    transform: translateY(0); } }\n\n@keyframes TextInput-Hint-module-Hint_show_23P {\n  from {\n    opacity: 0;\n    transform: translateY(-6px); }\n  to {\n    opacity: 1;\n    transform: translateY(0); } }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
